//This modal is no longer used. LaundromatPage.js is the page that renders instead.

import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import "react-datepicker/dist/react-datepicker.css";
import React, { useState, useEffect } from "react";
import Modal from 'react-awesome-modal';
import { observer } from "mobx-react";
import store from '../Stores/IbsSurveyStore'
import Slider, { Range,  createSliderWithTooltip } from 'rc-slider'
//import MaterialTable, { MTableToolbar } from "material-table";
import { MTableToolbar } from "material-table";
import { default as MaterialTable } from "mui-datatables";
import { TableCell } from '@material-ui/core';
import {
    createMuiTheme,
    MuiThemeProvider
} from "@material-ui/core/styles";
import { changeSurveyCtrl, changeSurveyStatusCtrl, changeSurveyCleanerCtrl, updateSurveyInfoCtrl } from '../../control';
import DatePicker from "react-datepicker";
import { toJS } from 'mobx';
import { formatAMPM } from '../../helpers';
//import { changeSurveyCleaner, changeSurveyStatus, changeSurvey } from '../../Services/PABS/PabsService';
//const createSliderWithTooltip = Slider.createSliderWithTooltip;
//const Ranger = createSliderWithTooltip(Range);



const IBSAdminPanel = observer(() => {
    //testing
    //const forceUpdateCustom = useForceUpdate();

    //end testing
    const [filterYearRange, setFilterYearRange] = useState([2000, 2023]);
    const [laundromateSelectedRowNew, setlaundromateSelectedRowNew] = useState([]);

    useEffect(() => {
        filterSurveys()
    }, [filterYearRange])

    const changeSlider = (value) => {
        setFilterYearRange(value)
        handleYearRangeFilter(value)

    }
    const closeAdminPanel = () => {
        store.showAdminPanel = false;
        store.viewSurveyDetails = false;
    }

    const beam = async () => {
        store.viewSurveyDetails = false;
        if (laundromateSelectedRowNew[2] === 'DC') {
            if (!window.location.href.includes('/dc')) {
                console.log("redirecting to DC")
                localStorage.removeItem("lastOpenedSurveyIdCacheDB");
                window.location.href = '/dc/home'
                localStorage.setItem("lastOpenedSurveyIdCacheDC", laundromateSelectedRowNew[0])
                localStorage.setItem("lastOpenedPlanID", laundromateSelectedRowNew[1])
                localStorage.setItem("lastOpenedProductType", "DC")

                return
            }
        }
        if (laundromateSelectedRowNew[2] === 'DB') {
            if (!window.location.href.includes('/db')) {
                console.log("redirecting to DB")
                window.location.href = '/db/home'
                localStorage.removeItem("lastOpenedSurveyIdCacheDC");
                localStorage.setItem("lastOpenedSurveyIdCacheDB", laundromateSelectedRowNew[0])
                localStorage.setItem("lastOpenedPlanID", laundromateSelectedRowNew[1])
                localStorage.setItem("lastOpenedProductType", "DB")
                return
            }
        }

        await changeSurveyCtrl(laundromateSelectedRowNew[0], laundromateSelectedRowNew[1], laundromateSelectedRowNew[2]);
        closeAdminPanel();
    }

    const columns = [
        {
            name: "SurveyID",
            options: {
                display: false
            }
        },
        {
            label: "Plan",
            name: "Plan",
            editable: "never",
            render: rowData => <React.Fragment>{rowData.Plan}</React.Fragment>
        },
        {
            label: "Partnership",
            name: "PlanPartnershipNameShort",
            editable: "never",
            render: rowData => <React.Fragment>{rowData.PlanPartnershipNameShort}</React.Fragment>
        },
        {
            label: "Product",
            name: "Product",
            editable: "never",
            render: rowData => <React.Fragment>{rowData.Product}</React.Fragment>
        },
        {
            label: "Country",
            editable: "never",
            name: "CountryName",

        },
        {
            label: "Year",
            editable: "never",
            name: "DataYear",

        },
        {
            editable: "never",
            label: "Received",
            name: "OriginalDateCompleted",
            options: {
                customBodyRender: value => {
                    if (value) {
                        let date = new Date(value);
                        return <React.Fragment>{formatAMPM(date)}</React.Fragment>;
                    }
                }
            },

        },
        {
            label: "Active",
            editable: "never",
            name: "LatestActivity",
            options: {
                customBodyRender: value => {
                    if (value) {
                        let date = new Date(value);
                        return <React.Fragment>{formatAMPM(date)}</React.Fragment>;
                    }
                }
            },
        },
        {
            label: "Changes",
            name: "NumChanges",
            editable: "never",
        },
        {
            label: "Status",
            name: "SurveyStatusID",
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    let rowData = tableMeta.currentTableData[tableMeta.rowIndex].data;
                    let surveyID = rowData[0];
                    return (
                        <select onChange={(e) => changeStatus(surveyID, e)}>
                            <option value="0" selected={value == undefined ? true : false}></option>
                            <option value="1" selected={value == 1 ? true : false}>Done</option>
                            <option value="2" selected={value == 2 ? true : false}>Web Validated</option>
                            <option value="3" selected={value == 3 ? true : false}>Don't Use</option>
                            <option value="4" selected={value == 4 ? true : false}>Needs Work</option>
                            <option value="5" selected={value == 5 ? true : false}>See memo</option>
                        </select>
                    );
                }
            },
        },
        {
            label: "Cleaner",
            name: "SurveyCleaners",

            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    let rowData = tableMeta.currentTableData[tableMeta.rowIndex].data;
                    let surveyID = rowData[0];
                    return (
                        <select onChange={(e) => changeCleaner(surveyID, e)}>
                            <option value="" selected={value == null ? true : false}></option>
                            <option value="DaveW" selected={value == "DaveW" ? true : false}>DaveW</option>
                            <option value="DaveD" selected={value == "DaveD" ? true : false}>DaveD</option>
                            <option value="Palwasha" selected={value == "Palwasha" ? true : false}>Palwasha</option>
                            <option value="Shayan" selected={value == "Shayan" ? true : false}>Shayan</option>
                            <option value="Rhijuta" selected={value == "Rhijuta" ? true : false}>Rhijuta</option>
                            <option value="Franco" selected={value == "Franco" ? true : false}>Franco</option>
                            <option value="Daniel" selected={value == "Daniel" ? true : false}>Daniel</option>
                            <option value="Maaike" selected={value == "Maaike" ? true : false}>Maaike</option>
                            <option value="Janjaap" selected={value == "Janjaap" ? true : false}>Janjaap</option>
                            <option value="Joao" selected={value == "Joao" ? true : false}>Joao</option>
                            <option value="Wladimir" selected={value == "Wladimir" ? true : false}>Wladimir</option>
                            <option value="Wildcard1" selected={value == "Wildcard1" ? true : false}>Wildcard1</option>
                            <option value="Wildcard2" selected={value == "Wildcard2" ? true : false}>Wildcard2</option>
                        </select>
                    );
                }
            },
        }

                //<input type="text" onBlur={(e) => changeCleaner(rowData.SurveyID, e)}
                //    style={{ width: '100px' }}
                //    //className="textInput def-textbox col-md-2"
                //    onChange={(e) => onUpdateCleanerText(rowData.SurveyID, e)}
                //    name={"DateQuestionSent"} value={rowData.SurveyCleaners}>
                //</input>

        // {
        //     label: "L2",
        //     editable: "never",
        //     width: "20px",
        //     render: rowData => <React.Fragment>{rowData.isL2 ? "yes" : "no"}</React.Fragment>
        // }

    ];
    const changeStatus = (surveyId, e) => {
        var statusId = parseInt(e.target.value)
        changeSurveyStatusCtrl(surveyId, statusId)
    }
    const changeCleaner = (surveyId, e) => {
        changeSurveyCleanerCtrl(surveyId, e.target.value)
    }
    const onUpdateCleanerText = (surveyID, e) => {
        //var currentSurvey = toJS(store.surveyListDisplay.filter(survey => survey.SurveyID == surveyID)[0])
        store.surveyListDisplay.filter(survey => survey.SurveyID == surveyID)[0].SurveyCleaners = e.target.value;
    }

    const handleYearRangeFilter = () => {
        filterSurveys()
    }

    const handleFilterTagClick = (filterName, filterCategory) => {
        if (store.filterTagsNew[filterCategory].includes(filterName)) {
            //remove from list
            var index = store.filterTagsNew[filterCategory].indexOf(filterName)
            store.filterTagsNew[filterCategory].splice(index, 1)
        } else {
            // add to filter list
            store.filterTagsNew[filterCategory].push(filterName)
        }
        filterSurveys()
    }

    const filterSurveys = (value = "") => {
        try {
            var filteredList;
            //Apparently this part does not matter...
            //  Both are the same
            if (window.location.href.includes('dc')) {
                filteredList = store.DCSurveysList;
            } else {
                filteredList = store.DBSurveysList;
                //console.log("laundromat", filteredList)
            } 
            if (filteredList) {
                if (store.filterTagsNew["SurveyStatus"].length == 0 && store.filterTagsNew["Product"].length == 0 && filterYearRange == [2000, 2023]) {
                    store.surveyListDisplay = filteredList;
                } else {
                    if (store.filterTagsNew["Product"].length != 0) {
                        filteredList = filteredList.filter(function (e) {
                            return store.filterTagsNew["Product"].includes(e.Product);
                        });
                    }
                    if (store.filterTagsNew["SurveyStatus"].length != 0) {
                        filteredList = filteredList.filter(function (e) {
                            return store.filterTagsNew["SurveyStatus"].includes(e.SurveyStatusID);
                        });
                    }

                    filteredList = filteredList.filter(function (e) {
                        return (e.DataYear >= filterYearRange[0] && e.DataYear <= filterYearRange[1])
                    });
                    store.surveyListDisplay = filteredList;
                }
            }

           
        } catch (error) {
            console.log("Error: could not filter list", error)
        }

    }

    //Big ugly code chunk for survey details
    var toggleLabel = store.viewSurveyDetails ? "Survey List" : "Survey Details";

    const onChangeText = (name, e) => {
        store.selectedSurvey[name] = e.target.value;
    }

    const updateSurveyDetails = () => {
        store.selectedSurvey = store.surveyListDisplay.filter(survey => survey.SurveyID == laundromateSelectedRowNew[0])[0];
        var test = toJS(store.selectedSurvey);
        var test5 = 5;
        test5++;
    }

    const toggleDetails = () => {

        var testValue = store.viewSurveyDetails;
        store.viewSurveyDetails = !testValue;
        if (store.viewSurveyDetails) {
            updateSurveyDetails();
        }

    }

    const onSurveyInfoChange = async (surveyId, fieldName, e) => {
        const newValue = e.target.value;
        await updateSurveyInfoCtrl(surveyId, fieldName, newValue);
    }

    const setDate = async (surveyId, fieldName, date) => {
        await updateSurveyInfoCtrl(surveyId, fieldName, date, true);
    }

    const getStringData = (input) => {
        if (typeof input === 'undefined' || input == null) {
            return "";
        }

        return String(input);
    }

    const EnhancedOptions = () => {
        var enhancedId = store.selectedSurvey.EnhancedInternalID;
        var id = store.selectedSurvey.SurveyID;
        return (
            <React.Fragment>
                <select onChange={(e) => onSurveyInfoChange(id, "EnhancedInternalID", e)} style={{ width: '100%' }}>
                    <option value="null" selected={enhancedId == null ? true : false}>...</option>
                    <option value="1" selected={enhancedId == 1 ? true : false}>Not available</option>
                    <option value="2" selected={enhancedId == 2 ? true : false}>Available to users and admins</option>
                </select>
            </React.Fragment>
            )
    }

    const UserDefaultOptions = () => {
        var hasUserConfirmedDefaults = store.selectedSurvey.HasUserConfirmedDefaults;
        var id = store.selectedSurvey.SurveyID;
        return (
            <React.Fragment>
                <select onChange={(e) => onSurveyInfoChange(id, "HasUserConfirmedDefaults", e)} style={{ width: '100%' }}>
                    <option value="null" selected={hasUserConfirmedDefaults == null ? true : false}>...</option>
                    <option value="1" selected={hasUserConfirmedDefaults == 1 ? true : false}>Yes</option>
                    <option value="2" selected={hasUserConfirmedDefaults == 2 ? true : false}>No</option>
                    <option value="3" selected={hasUserConfirmedDefaults == 3 ? true : false}>N/A</option>
                </select>
            </React.Fragment>
        )
    }

    const PrivateEquityOptions = () => {
        var privateEquityStatusTypeID = store.selectedSurvey.PrivateEquityStatusTypeID;
        var id = store.selectedSurvey.SurveyID;
        return (
            <React.Fragment>
                <select onChange={(e) => onSurveyInfoChange(id, "PrivateEquityStatusTypeID", e)} style={{width:'100%'}}>
                    <option value="null" selected={privateEquityStatusTypeID == null ? true : false}>...</option>
                    <option value="1" selected={privateEquityStatusTypeID == 1 ? true : false}>Done</option>
                    <option value="2" selected={privateEquityStatusTypeID == 2 ? true : false}>Web Validated</option>
                    <option value="3" selected={privateEquityStatusTypeID == 3 ? true : false}>Don't Use</option>
                    <option value="4" selected={privateEquityStatusTypeID == 4 ? true : false}>Needs Work</option>
                    <option value="5" selected={privateEquityStatusTypeID == 5 ? true : false}>See memo</option>
                </select>
            </React.Fragment>
        )
    }

    const getMuiTheme = () =>
        createMuiTheme({
            overrides: {
                MUIDataTableHeadRow: {
                    root: {
                        backgroundColor: "rgb(91, 100, 109)",
                        color: "#FFFFFF"
                    }
                },
                MuiButton: {
                    root: {
                        color: "#FFFFFF"
                    }
                },
                MUIDataTableBodyRow: {
                    root: {
                        height: "43px",
                        '&:hover': {
                            cursor: "pointer"
                        }
                    },
                },
                MUIDataTableBodyCell: {
                    root: {
                        textAlign: "center"
                    }
                },
                MuiTablePagination: {
                    caption: {
                        color: "#467175",
                        fontSize: "0.75rem"
                    }
                },
                MUIDataTableHeadCell: {
                    root: {
                        backgroundColor: "rgb(91, 100, 109)",
                        color: "#FFFFFF",
                        textAlign: "center",
                        '&:nth-child(1)': {
                            // Plan
                            width: "11%"
                        },
                        '&:nth-child(2)': {
                            // Partnership
                            width: "10%"
                        },
                        '&:nth-child(3)': {
                            // Product
                            width: "6%"
                        },
                        '&:nth-child(4)': {
                            // Country
                            width: "12%"
                        },
                        '&:nth-child(5)': {
                            // Year
                            width: "5%"
                        },
                        '&:nth-child(6)': {
                            // Received
                            width: "12%"
                        },
                        '&:nth-child(7)': {
                            // Active
                            width: "12%"
                        },
                        '&:nth-child(8)': {
                            // Changes
                            width: "8%"
                        },
                        '&:nth-child(9)': {
                            // Status
                            width: "12%"
                        },
                        '&:nth-child(10)': {
                            // Cleaner
                            width: "12%"
                        },
                    },
                    button: {
                        color: "#FFFFFF",
                        textAlign: "center"
                    },
                    sortActive: {
                        color: "#FFFFFF"
                    },
                    toolButton: {
                        marginLeft: 0
                    },
                    contentWrapper: {
                        display: "block",
                        margin: "0 auto"
                    }
                },
                MUIDataTable: {
                    paper: {
                        height: '80%',
                    },
                    responsiveScroll: {
                        maxHeight: 'none',
                        height: 'calc(100% - 128px)'
                    },
                    tableRoot: {
                        tableLayout: "fixed"
                    }
                },
                MUIDataTableToolbar: {
                    titleRoot: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center"
                    }
                }
            }
        });

    return (
        <React.Fragment>
            <section>
                <Modal
                    visible={store.showAdminPanel}
                    width="1445"
                    height="650"
                    effect="fadeInDown"
                    onClickAway={closeAdminPanel}>

                    <div className="adminPanel">
                        <div className="row wrapOverride">
                            {!store.viewSurveyDetails && 
                                <div id="laundromat-table2">
                                <MuiThemeProvider theme={getMuiTheme()}>
                                    <MaterialTable
                                        title={
                                            <div class="MUIDataTableToolbar-titleRoot-19" aria-hidden="true">
                                                <i className="fas fa-folder-open"></i>
                                                <h6 class="MuiTypography-root MUIDataTableToolbar-titleText-20 MuiTypography-h6">Laundromat</h6>
                                            </div>
                                        }
                                        options={{
                                            draggable: false,
                                            pagination: true,
                                            rowsPerPage: 10,
                                            selectableRows: "single",
                                            selectableRowsHeader: false,
                                            selectableRowsHideCheckboxes: true,
                                            selectToolbarPlacement: "none",
                                            filter: false,
                                            print: false,
                                            download: false,
                                            viewColumns: false,
                                            fixedHeader: false,
                                            onRowClick: (rowData, rowMeta) => {
                                                let rawRowData = store.surveyListDisplay[rowMeta.dataIndex];
                                                setlaundromateSelectedRowNew([rawRowData.SurveyID, rawRowData.PlanID, rawRowData.Product, rawRowData.DataYear, rowMeta.dataIndex]);
                                            },
                                            tableBodyMaxHeight: "100%",
                                            tableBodyHeight: "100%",
                                            textLabels: {
                                                pagination: {
                                                    next: "Next Page",
                                                    previous: "Previous Page",
                                                    rowsPerPage: "",
                                                    displayRows: "of",
                                                }
                                            },
                                            rowsSelected: laundromateSelectedRowNew.length > 0 ? [laundromateSelectedRowNew[4]] : []
                                        }}
                                        columns={columns}
                                        data={store.surveyListDisplay}

                                    />
                                </MuiThemeProvider>
                                </div>
                            }
                            {
                                store.viewSurveyDetails &&
                                <div id="laundromat-details">
                                    <div className="laundromatToolbar" style={{display:'flex', alignItems:'center'}}>
                                        <i className="fas fa-folder-open"></i>
                                        <div className="MuiToolbar-root MuiToolbar-regular MTableToolbar-root-5 MuiToolbar-gutters">
                                            <div className="MTableToolbar-title-9" style={{ minHeight: '64px' }}>
                                                <h6 className="MuiTypography-root MuiTypography-h6" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'hidden', textOverflow: 'ellipsis', paddingTop:'15px', paddingLeft:'15px' }}>{"Survey Administration: " + store.selectedSurvey.Plan + " (" + (store.selectedSurvey.ProductID == 2 ? "DC" : "DB") + ")"}</h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{paddingTop:'15px'}}>
                                        <div className="row laundromatRow">
                                            <div className="col-md-3">
                                                <span className="comment-heading">Data Year: </span>  &nbsp;  <br />
                                            </div>
                                            <div className="col-md-2">
                                                <span className="comment-heading">{getStringData(store.selectedSurvey.DataYear)}</span><br />
                                            </div>
                                            <div className="col-md-1" />

                                            <div className="col-md-3">
                                                <span className="comment-heading">Date First Submitted: </span>  &nbsp;  <br />
                                            </div>
                                            <DatePicker
                                                dateFormat="MM/dd/yyyy HH:mm"
                                                showTimeSelect
                                                selected={store.selectedSurvey.OriginalDateCompleted != null ? new Date(store.selectedSurvey.OriginalDateCompleted) : null}
                                                onChange={date => setDate('OriginalDateCompleted', date)} />
                                            <div className="col-md-1" />
                                        </div>

                                        <div className="row laundromatRow">
                                            <div className="col-md-3">
                                                <span className="comment-heading">Enhanced Internal: </span>  &nbsp;  <br />
                                            </div>
                                            <div className="col-md-2">
                                                {EnhancedOptions()}
                                            </div>
                                            <div className="col-md-1" />

                                            <div className="col-md-3">
                                                <span className="comment-heading">Question Sent Date: </span>  &nbsp;  <br />
                                            </div>
                                            <DatePicker
                                                dateFormat="MM/dd/yyyy HH:mm"
                                                showTimeSelect
                                                selected={store.selectedSurvey.DateQuestionSent != null ? new Date(store.selectedSurvey.DateQuestionSent) : null}
                                                onChange={date => setDate('DateQuestionSent', date)} />
                                            <div className="col-md-1" />
                                        </div>

                                        <div className="row laundromatRow">
                                            <div className="col-md-3">
                                                <span className="comment-heading">Use of Imputations: </span>  &nbsp;  <br />
                                            </div>
                                            <div className="col-md-2">
                                                {UserDefaultOptions()}
                                            </div>
                                            <div className="col-md-1" />

                                            <div className="col-md-3">
                                                <span className="comment-heading">Private Equity Status: </span>  &nbsp;  <br />
                                            </div>
                                            <div className="col-md-2">
                                                {PrivateEquityOptions()}
                                            </div>
                                            <div className="col-md-1" />
                                        </div>

                                        <div className="row laundromatRow">
                                            <div className="col-md-3">
                                                <span className="comment-heading">Latest Activity: </span>  &nbsp;  <br />
                                            </div>
                                            <div className="col-md-2">
                                                <span className="comment-heading">{getStringData(store.selectedSurvey.LatestActivity)}</span><br />
                                            </div>
                                            <div className="col-md-1" />

                                            <div className="col-md-3">
                                                <span className="comment-heading">Last Submit At: </span>  &nbsp;  <br />
                                            </div>
                                            <div className="col-md-2">
                                                <span className="comment-heading">{getStringData(store.selectedSurvey.LatestActivity)}</span><br />
                                            </div>
                                            <div className="col-md-1" />
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="col-md-3 filter-col">
                                <div style={{textAlign:'center', marginTop:'24px'}}><span style={{ color: '#718486', fontSize: '18px'}}>Filter Surveys</span></div>
                                <fieldset style={{ width: 'auto', border: '1px solid #7eb0b561' }}>
                                    <legend style={{ width: 'auto', padding: '5px', fontSize: '15px', marginBottom: '0px' }}><i className="fa fa-filter" aria-hidden="true"></i>Search Criteria &nbsp;</legend>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div style={{ padding: '5px' }}>
                                                <input type="checkbox" id="done" name="done" onClick={() => handleFilterTagClick(1, "SurveyStatus")}></input>
                                                <label htmlFor="done">Done</label>
                                            </div>
                                            <div style={{ padding: '5px' }}>
                                                <input type="checkbox" id="webValidated" name="webValidated" onClick={() => handleFilterTagClick(2, "SurveyStatus")}></input>
                                                <label htmlFor="webValidated">Web Validated</label>
                                            </div>
                                            <div style={{ padding: '5px' }}>
                                                <input type="checkbox" id="needsWork" name="needsWork" onClick={() => handleFilterTagClick(4, "SurveyStatus")}></input>
                                                <label htmlFor="needsWork">Needs Work</label>
                                            </div>
                                            <div style={{ padding: '5px' }}>
                                                <input type="checkbox" id="seeMemo" name="seeMemo" onClick={() => handleFilterTagClick(5, "SurveyStatus")}></input>
                                                <label htmlFor="seeMemo">See Memo</label>
                                            </div>


                                        </div>
                                        <div className="col-md-6">
                                            <div style={{ padding: '5px' }}>
                                                <input type="checkbox" id="dontUse" name="dontUse" onClick={() => handleFilterTagClick(3, "SurveyStatus")}></input>
                                                <label htmlFor="dontUse">Don't Use</label>
                                            </div>
                                            <div style={{ padding: '5px' }}>
                                                <input type="checkbox" id="noStatus" name="noStatus" onClick={() => handleFilterTagClick(null, "SurveyStatus")}></input>
                                                <label htmlFor="noStatus">No Status</label>
                                            </div>

                                            <div style={{ padding: '5px' }}>
                                                <input type="checkbox" id="dc" name="dc" onClick={() => handleFilterTagClick("DC", "Product")}></input>
                                                <label htmlFor="dc">DC</label>
                                            </div>
                                            <div style={{ padding: '5px' }}>
                                                <input type="checkbox" id="db" name="db" onClick={() => handleFilterTagClick("DB", "Product")}></input>
                                                <label htmlFor="db">DB</label>
                                            </div>
                                        </div>
                                    </div>

                                </fieldset>
                                <fieldset style={{ width: 'auto', border: '1px solid #7eb0b561' }}>
                                    <legend style={{ width: 'auto', padding: '5px', fontSize: '15px', marginBottom: '0px' }}><i className="fa fa-filter" aria-hidden="true"></i> Year Range &nbsp;</legend>

                                    <div>
                                        <div className="sliderCustom">
                                            <div style={{ textAlign: 'center', marginBottom: '10px' }}><span className="sliderRangeValues">{filterYearRange[0]} - {filterYearRange[1]}</span></div>
                                            <Range min={2000} max={2020} defaultValue={filterYearRange} onChange={changeSlider} allowCross={false} />
                                        </div>
                                    </div>
                                </fieldset>
                                <button type="button" className="btn btn-beam" onClick={toggleDetails} disabled={laundromateSelectedRowNew.length == 0}>{toggleLabel}</button>
                                <button type="button" className="btn btn-beam" onClick={beam}>Beam</button>
                            </div>

                            <span onClick={closeAdminPanel} style={{ padding: '0px 16px' }} className="close-button topright">&times;</span>

                        </div>
                    </div>

                </Modal>
            </section>
        </React.Fragment>
    );

});

export default IBSAdminPanel;

